import { LoadOptions } from "react-select-async-paginate";
import { OptionType } from "../shared/components/BaseAsyncPaginate";
import { PER_PAGE } from "pages/admin-app/adminapp.constants";

export interface PaginationMeta {
  page: number;
  totalPages: number;
  perPage: number;
}

export interface Response<T> {
  data: T[];
  meta: PaginationMeta;
  message: string | null;
  status: string | null;
}

export type FetchFn<T> = (
  page: number,
  perPage: number,
  searchQuery?: string
) => Promise<Response<T>>;

export function createLoadOptions<T>(
  fetchFn: FetchFn<T>,
  mapper: (item: T) => OptionType,
  perPage: number = PER_PAGE
): LoadOptions<OptionType, { page: number }> {
  return async (
    search: string,
    _loadedOptions: OptionType[],
    additional: { page: number } = { page: 1 }
  ) => {
    try {
      const response = await fetchFn(additional.page, perPage, search);
      const options = response.data.map(mapper);
      const hasMore = additional.page < response.meta.totalPages;
      return {
        options,
        hasMore,
        additional: { page: additional.page + 1 },
      };
    } catch (error) {
      console.error("Error in loadOptions:", error);
      return {
        options: [],
        hasMore: false,
        additional,
      };
    }
  };
}
